import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const URL = `${process.env.REACT_APP_BACKEND_HOSTED_ON}${process.env.REACT_APP_SUBMIT_SIGN_UP_FORM}`;

export const generateEmailLink = createAsyncThunk(
  "generate/email/verificationAgain",
  async (userData, thunkApi) => {
    try {
      const response = await axios.post(URL, userData);
      return response.data;
    } catch (error) {
      //* You can handle error cases and return custom error messages or perform additional actions here
      return thunkApi.rejectWithValue(error.response.data);
    }
  }
);

export const generateEmailLinkSlice = createSlice({
  name: "generateEmailLinkAgin",
  initialState: {
    formSubmitted: false,
    response: null,
    loading: false,
    success: false,
    error: null,
    verificationLinkAgainMsg: null,
    verificationLinkAgainBtn: true,
  },
  reducers: {
    formSubmittedAgain: (state) => {
      state.formSubmitted = false;
    },
    resendEmailVerificationLinkTimer: (state) => {
      // Add 1 minute to the current date
      let currentTime = new Date();
      currentTime.setMinutes(currentTime.getMinutes() + 1);
      state.verificationLinkAgainMsg = `please wait for at ${currentTime.toLocaleTimeString()} before requesting the verification link again.`;
    },
    enableRequestVerificationLinkBtn: (state) => {
      state.verificationLinkAgainBtn = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateEmailLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateEmailLink.fulfilled, (state, action) => {
        state.response = action.payload;
        state.loading = false;
        state.error = null;
        state.success = action.payload.success;
        state.formSubmitted = true;
        state.verificationLinkAgainBtn = false;
      })
      .addCase(generateEmailLink.rejected, (state, action) => {
        state.error =
          action.payload?.msg ||
          "Some thing bad in our server please try some time later";
        state.loading = false;
        state.response = null;
        state.success = false;
        state.formSubmitted = true;
      });
  },
});

export const {
  formSubmittedAgain,
  enableRequestVerificationLinkBtn,
  resendEmailVerificationLinkTimer,
} = generateEmailLinkSlice.actions;

export default generateEmailLinkSlice.reducer;
